module.exports = __webpack_public_path__ + "media/images/360/about-4b7f55987b38f34d8674102aa989e8ce.jpg";